// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.retirement-plan-container {
  min-height: 100vh;
  /* will cover the 100% of viewport */
  background-color: #e0e0e0;
  position: relative;
  display: block;
  font-style: normal !important;
}
.retirement-plan-container .login-container {
  min-height: 90vh;
}
.retirement-plan-container .login-container .login {
  margin-top: 150px;
  height: 350px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.6) 11.97%, rgba(255, 255, 255, 0) 77.22%);
  border: 2px solid #ffffff;
  box-sizing: border-box;
  border-radius: 83px;
}
.retirement-plan-container .login-container .login .login-title-wrapper {
  padding: 30px;
}
.retirement-plan-container .login-container .login .login-title-wrapper .lcontainer {
  display: grid;
  grid-template-columns: 1fr 1fr 2fr;
  grid-template-rows: 50px;
}
.retirement-plan-container .login-container .login .login-title-wrapper .lcontainer .logo > img {
  width: 70px;
  height: 70px;
  object-fit: cover;
}
.retirement-plan-container .login-container .login .login-title-wrapper .logo-class {
  font-style: normal;
  font-weight: bold;
  font-family: "Noto Sans", Arial, sans-serif;
  font-size: 30px;
  letter-spacing: -0.08em;
  color: #059baf;
  padding: 15px 0px 0px 0px;
}
.retirement-plan-container .login-container .login .login-title-wrapper .logo-tagline-class {
  font-size: 10px;
  color: #009fe3;
  font-weight: 700;
  padding: 35px 0px 0px 5px;
}
.retirement-plan-container .login-container .login .login-fields .user-email-field {
  width: 100%;
  padding: 5px;
}
.retirement-plan-container .login-container .login .login-fields .user-password-field {
  width: 100%;
  padding: 5px;
}
.retirement-plan-container .login-container .login .login-buttons {
  padding: 10px 0 0;
  display: flex;
  justify-content: center;
}
.retirement-plan-container .login-container .login .login-buttons .sign-in-button,
.retirement-plan-container .login-container .login .login-buttons .sign-up-button {
  font-size: 12px;
  background: radial-gradient(58.52% 47.51% at 56.65% 47.58%, #059baf 0%, #007080 100%);
  border: 2px solid #ffffff;
  border-radius: 9px;
  padding: 2px;
  margin: 10px;
}
.retirement-plan-container .login-container .login .login-buttons .sign-in-button .MuiButton-root,
.retirement-plan-container .login-container .login .login-buttons .sign-up-button .MuiButton-root {
  padding: 0px;
  color: #ffffff;
}
.retirement-plan-container .login-container .login .login-buttons .sign-in-button .MuiButton-contained,
.retirement-plan-container .login-container .login .login-buttons .sign-up-button .MuiButton-contained {
  box-shadow: none !important;
}
.retirement-plan-container .login-container .login .login-buttons .sign-in-button .MuiButton-containedPrimary,
.retirement-plan-container .login-container .login .login-buttons .sign-in-button .MuiButton-containedPrimary:hover,
.retirement-plan-container .login-container .login .login-buttons .sign-up-button .MuiButton-containedPrimary,
.retirement-plan-container .login-container .login .login-buttons .sign-up-button .MuiButton-containedPrimary:hover {
  background: radial-gradient(58.52% 47.51% at 56.65% 47.58%, #059baf 0%, #007080 100%);
}
.retirement-plan-container .login-container .login .forgot-pwd-container {
  justify-content: center;
  display: flex;
}
.retirement-plan-container .login-container .login .forgot-pwd-container .forgot-pwd-button {
  cursor: pointer;
  text-transform: none;
  text-decoration: underline;
}
.retirement-plan-container .login-container .chart-container .chart-div {
  width: 100%;
  height: 75%;
}
@media (max-width: 767px) {
  .retirement-plan-container .login-container .chart-container .chart-div {
    max-width: 100%;
    max-height: 100%;
  }
}
@media (min-width: 768px) {
  .retirement-plan-container .login-container .chart-container .chart-div {
    max-width: 400px;
    max-height: 450px;
  }
}
@media (min-width: 992px) {
  .retirement-plan-container .login-container .chart-container .chart-div {
    max-width: 450px;
    max-height: 450px;
  }
}
@media (min-width: 1200px) {
  .retirement-plan-container .login-container .chart-container .chart-div {
    max-width: 500px;
    max-height: 500px;
  }
}
.retirement-plan-container .login-container .chart-container .inner-radius {
  border-radius: 80px;
  width: 125px;
  height: 125px;
  background: linear-gradient(92.79deg, #009fe3 6.52%, #00a19a 71.42%);
  border: 1px solid #ffffff;
  box-sizing: border-box;
  top: 238px;
  left: 287px;
  text-align: center;
  vertical-align: middle;
  position: absolute;
  box-shadow: 0 0 10px 1px #ffffff inset;
  padding-top: 50px;
  color: #ffffff;
  font-size: 12px;
}
.retirement-plan-container .login-container .login-client-container {
  margin-top: 200px;
  height: 250px;
  background: linear-gradient(270deg, rgba(255, 255, 255, 0.7) 38.89%, rgba(255, 255, 255, 0) 91.66%);
  border-radius: 83px;
}
.retirement-plan-container .login-container .login-client-container .client-login-dashboard-title {
  display: grid;
  grid-template-columns: 2fr 3fr 2fr;
  grid-template-rows: 50px;
  margin-top: 30px;
  font-size: 18px;
  font-weight: 400;
}
.retirement-plan-container .login-container .login-client-container .client-login-fields .client-dropdown {
  width: 100%;
  padding: 10px;
}
.retirement-plan-container .login-container .login-client-container .client-login-fields .plan-dropdown {
  width: 100%;
  padding: 10px;
}
.retirement-plan-container .login-container .login-client-container .client-dashboard-button-container {
  padding: 10px;
  width: 50%;
}
.retirement-plan-container .login-container .login-client-container .client-dashboard-button-container .client-goto-dashboard-button {
  background: #1890ff;
  border-radius: 9px;
  height: auto;
  padding: 5px;
  text-align: center;
  position: relative;
  left: 50%;
}
.retirement-plan-container .login-container .login-client-container .client-dashboard-button-container .client-goto-dashboard-button .MuiButton-root {
  padding: 0px;
  color: #ffffff;
  font-size: 14px;
  font-weight: 400;
  text-transform: none;
}
.retirement-plan-container .login-container .login-client-container .client-dashboard-button-container .client-goto-dashboard-button .MuiButton-contained {
  box-shadow: none !important;
}
.retirement-plan-container .simulate-buttons {
  padding: 2px 2px 0;
  max-width: fit-content;
  margin-top: 10px;
}
.retirement-plan-container .simulate-buttons button {
  background-color: rgb(34, 94, 168) !important;
  color: #fff;
  padding: 4px;
  border-radius: 5px;
  height: 30px;
}
.retirement-plan-container .simulate-buttons button .MuiButton-startIcon {
  margin: 0;
}
.retirement-plan-container .simulate-buttons button .MuiButton-iconSizeMedium {
  margin-right: 0;
}
.retirement-plan-container .review-form-grid {
  margin: 0 4px;
  padding-top: 16px;
}
.retirement-plan-container .review-form-grid .MuiFormControl-root {
  width: 100%;
}
.retirement-plan-container .page-header {
  padding-top: 8px;
}
.retirement-plan-container .page-header .page-title {
  padding-left: 8px;
}
.retirement-plan-container .page-header .page-title .sub-title {
  font-weight: bold;
  color: #89c5d3;
}
.retirement-plan-container .avatar .MuiAvatar-root {
  height: 30px;
  width: 30px;
}
.retirement-plan-container .avatar .MuiAvatar-colorDefault {
  background-color: rgba(255, 255, 255, 0.4);
}
.retirement-plan-container .cta-container .cta-header {
  border-radius: 4px;
  text-align: center;
  margin-bottom: 5px;
  padding: 5px;
  color: #ffffff;
}
.retirement-plan-container .cta-container .cta-header .MuiTypography-root {
  font-size: 14px;
  font-weight: 600;
}
.retirement-plan-container .cta-container .cta-buttons {
  max-width: fit-content;
}
.retirement-plan-container .cta-container .cta-buttons button {
  background-color: #009fe3;
  border-radius: 8px;
  height: 25px;
}
.retirement-plan-container .cta-container .cta-buttons button .MuiButton-startIcon {
  margin: 0;
}
.retirement-plan-container .cta-container .cta-buttons button .MuiButton-iconSizeMedium {
  margin-right: 0;
}

.signup-title-container {
  border-bottom: 1px solid #cccccc;
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
}
.signup-title-container .signup-title {
  font-size: 18px;
  font-weight: bold;
  display: inline-block;
  padding-bottom: 10px;
  color: #3e9479;
}
.signup-title-container .signup-title-close-icon {
  color: #666666;
  right: 25px;
  font-size: 14px;
}

.signup-body-container {
  padding-top: 12px;
}
.signup-body-container .signup-form-grid {
  margin: 0 4px;
  padding-top: 5px;
}
.signup-body-container .signup-form-grid .controls-input label {
  color: #fff;
}
.signup-body-container .signup-form-grid .controls-select label {
  color: #fff;
}
.signup-body-container .newplan-form-grid {
  margin: 0 4px;
  padding-top: 5px;
}
.signup-body-container .newplan-form-grid .controls-input label {
  color: #666666;
}
.signup-body-container .newplan-form-grid .controls-select label {
  color: #666666;
}

.signup-loader {
  position: absolute;
  top: 50%;
  z-index: 1;
  left: 50%;
}

.direct-user-header .MuiPaper-root {
  width: 100% !important;
}

.header-container {
  min-height: 94vh;
}
.header-container .body-container {
  margin: 10px;
}
.header-container .feedback-button {
  padding: 4px 2px 0;
  max-width: fit-content;
}
.header-container .feedback-button button {
  background-color: #fbc02d;
  text-transform: none;
  padding: 5px;
  border-radius: 4px;
  height: 25px;
  font-weight: bold;
}
.header-container .feedback-button button .MuiButton-startIcon {
  margin: 0;
}
.header-container .feedback-button button .MuiButton-iconSizeMedium {
  margin-right: 4px;
}
.header-container .side-drawer {
  padding-top: 10px;
  height: 100%;
}
.header-container .side-drawer .MuiDrawer-paper {
  width: 63px;
  background: linear-gradient(180.61deg, #00a19a 9.35%, #009fe3 106.9%);
  overflow-x: hidden;
}
.header-container .side-drawer .greenr-logo {
  background-color: #fff;
  margin-left: -14px;
  height: 30px;
  min-height: 50px;
}
.header-container .side-drawer .side-nav-list {
  list-style: none;
  font-size: 11px;
  padding: 2px;
  justify-content: center;
}
.header-container .side-drawer .side-nav-list .list-item {
  color: #ffffff;
  display: block;
  text-decoration: none;
  text-align: -webkit-center;
  cursor: pointer;
  margin-bottom: 20px;
  line-height: 20px;
}
.header-container .side-drawer .side-nav-list .list-item-current {
  background: #f8f8f8;
  box-shadow: 0px 4px 9px rgba(0, 0, 0, 0.35);
  border-radius: 10px;
  color: #009fe3;
}
.header-container .side-drawer .side-nav-list .list-item .list-item-icon {
  margin: 10px 0 0 0px;
}
.header-container .appbar-bg {
  background-color: #288693;
}
.header-container .header-name {
  margin: 0 5px;
}
.header-container .header-tag {
  font-size: 1rem;
}
.header-container .header-btn {
  box-shadow: none;
  border: none;
  background-color: transparent;
}
.header-container .header-btn:hover {
  background-color: transparent;
}
.header-container .logo-container {
  padding-left: 5px;
  min-height: 50px;
  height: 30px;
}
.header-container .header-logo {
  font-style: normal;
  color: #ffffff;
  display: inline-flex;
  align-items: center;
}
.header-container .header-logo .logo-class {
  font-style: normal;
  font-weight: bold;
  font-family: "Noto Sans", Arial, sans-serif;
  font-size: 30px;
  line-height: 37px;
  letter-spacing: -0.05em;
  margin-left: 10px;
}
.header-container .header-logo .logo-tagline-class {
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
  margin-left: 8px;
}
.header-container .header-logo .logo-pipe-class {
  margin-left: 8px;
  font-style: normal;
  font-weight: 100;
  font-size: 30px;
  line-height: 24px;
  color: #ffffff;
  opacity: 0.5;
}

.impact-container {
  position: relative;
}

.before-after-wrapper .planner-simulate-grid {
  position: relative;
  margin: 5px 0;
}
.before-after-wrapper .planner-simulate-grid .tile-it-button {
  margin-top: 15px !important;
  position: absolute;
  top: -50px;
  right: 0;
}
.before-after-wrapper .planner-simulate-grid .simulate-grid {
  position: absolute;
  left: 4px;
}
.before-after-wrapper .planner-simulate-grid .simulate-preview-header .MuiDataGrid-columnSeparator {
  display: none;
}
.before-after-wrapper .planner-simulate-grid .simulate-preview-header .MuiDataGrid-columnHeaderTitleContainer {
  padding: 0;
}
.before-after-wrapper .planner-simulate-grid .simulate-preview-header .MuiDataGrid-columnHeaderTitle {
  font-weight: bold;
  color: #555555;
  text-transform: uppercase;
}
.before-after-wrapper .planner-simulate-grid .simulate-preview {
  color: #555555;
  font-weight: bold;
  width: 100%;
  height: 400px;
}
.before-after-wrapper .planner-simulate-grid .simulate-preview .MuiDataGrid-root {
  border: none;
}
.before-after-wrapper .planner-simulate-grid .simulate-list-item {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  margin-bottom: 6px;
  font-size: 12px;
  padding: 10px;
  height: 45px;
}
.before-after-wrapper .planner-simulate-grid .simulate-list-item .list-title {
  width: 60%;
  position: relative;
  z-index: 1000;
}
.before-after-wrapper .planner-simulate-grid .simulate-list-item .list-beforeId,
.before-after-wrapper .planner-simulate-grid .simulate-list-item .list-afterId {
  padding: 0;
  width: 10%;
  justify-content: right;
}
.before-after-wrapper .planner-simulate-grid .simulate-list-item .list-beforeId {
  padding: 4px;
}
.before-after-wrapper .planner-simulate-grid .simulate-list-item .MuiListItemText-primary {
  font-size: 12px;
}
.before-after-wrapper .planner-simulate-grid .simulate-list-container {
  margin-top: 30px;
}
.before-after-wrapper .planner-simulate-grid .before-after-section {
  display: flex;
  justify-content: space-between;
  margin-left: auto;
  max-width: 35%;
}
.before-after-wrapper .planner-simulate-grid .before-after-section > div:first-child {
  margin-right: 8px;
}
.before-after-wrapper .planner-simulate-grid .before-after-section .before-title {
  font-weight: bold;
  color: #555555;
  text-transform: uppercase;
  font-size: 14px;
  color: #555555;
  border: 1px solid #555555;
  height: 350px;
  padding: 4px;
  border-style: dashed;
  border-radius: 10px;
  width: 50%;
  text-align: center;
}

.menu-items {
  margin-top: 10px;
}

.d-block {
  display: block;
}

.d-none {
  display: none;
}

.profile-container {
  padding: 0 !important;
}

.solutions-container {
  padding: 0 !important;
}

.charts-container {
  padding: 0 !important;
}

.direct-user-container {
  padding-left: 0 !important;
}

.dashboard-container {
  padding: 20px 0px 0px 70px;
}
.dashboard-container label,
.dashboard-container input,
.dashboard-container button,
.dashboard-container .MuiInputBase-input,
.dashboard-container .MuiMenuItem-root {
  font-size: 12px;
}
.dashboard-container .dropdown-class {
  background: linear-gradient(180deg, #ffffff 0%, rgba(255, 255, 255, 0) 183.75%);
}
.dashboard-container .no-chart-container .no-chart-div {
  width: 350px;
  height: 350px;
}
.dashboard-container .chart-container {
  padding: 50px 0px 0px 35px;
  cursor: pointer;
}
.dashboard-container .chart-container .chart-div {
  width: 350px;
  height: 350px;
}
.dashboard-container .chart-container .inner-radius {
  border-radius: 50px;
  width: 88px;
  height: 88px;
  background: linear-gradient(92.79deg, #009fe3 6.52%, #00a19a 71.42%);
  border: 1px solid #ffffff;
  box-sizing: border-box;
  top: 191px;
  left: 166px;
  text-align: center;
  vertical-align: middle;
  position: absolute;
  box-shadow: 0 0 10px 1px #ffffff inset;
  padding-top: 35px;
  color: #ffffff;
  font-size: 10px;
}
.dashboard-container .chart-container .inner-radius-unsubscribed {
  border-radius: 50px;
  width: 88px;
  height: 88px;
  border: 1px solid #ffffff;
  box-sizing: border-box;
  top: 191px;
  left: 166px;
  text-align: center;
  vertical-align: middle;
  position: absolute;
  box-shadow: 0 0 10px 1px #ffffff inset;
  padding-top: 35px;
  color: black;
  font-size: 10px;
}
.dashboard-container .chart-container .link-style {
  text-decoration: none;
  vertical-align: middle;
}
.dashboard-container .chart-container .link-text {
  font-size: 10px;
  color: black;
  vertical-align: top;
}
.dashboard-container .ds-common-container {
  width: 100% !important;
  padding: 10px !important;
}
.dashboard-container .common-container {
  padding: 60px 0px 10px 0px;
  width: 74%;
}
.dashboard-container .common-container .MuiAccordionSummary-root {
  min-height: 25px;
}
.dashboard-container .common-container .MuiAccordionDetails-root {
  padding-top: 0;
}
.dashboard-container .common-container .chrono-charts-container {
  background: rgba(255, 255, 255, 0.3);
  box-sizing: border-box;
  box-shadow: -5px 4px 34px rgba(85, 85, 85, 0.04);
  border-radius: 10px;
  min-height: 62px;
  margin: 15px 0px 10px 0px;
  padding: 10px;
}
.dashboard-container .common-container .chrono-charts-container .chrono-list-wrapper {
  padding: 0px !important;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  margin-top: 2px;
}
.dashboard-container .status-list-container {
  background: #479573;
  width: 80%;
  border-radius: 12px;
  padding: 8px 20px 2px 20px;
  margin: 45px 0px 10px 40px;
}
.dashboard-container .status-list-container .status-list-div {
  min-height: 385px;
  max-height: 450px;
  overflow: auto;
}
.dashboard-container .status-list-container .status-list {
  list-style: none;
  color: white;
  font-size: 12px;
  padding: 0px;
}
.dashboard-container .status-list-container .list-item {
  cursor: pointer;
  padding: 8px 16px;
}
.dashboard-container .status-list-container .list-item-current {
  background: rgba(255, 255, 255, 0.75);
  border: 1px solid rgba(225, 253, 151, 0.3);
  box-sizing: border-box;
  border-radius: 7px;
}
.dashboard-container .status-list-container .list-item-current .label {
  color: black;
}
.dashboard-container .status-list-container .list-item-current .list-item-label {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: #000000;
}
.dashboard-container .status-list-container .status-title {
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 21px;
  text-transform: uppercase;
  color: #ffffff;
  margin-bottom: 20px;
}
.dashboard-container .status-list-container .hr-line {
  border-top: 0.5px dashed white;
  margin: 0 16px 0 16px;
}
.dashboard-container .status-list-container .notes-section .MuiTextField-root input::placeholder {
  font-size: 10px;
}
.dashboard-container .status-list-container .notes-section .MuiTextField-root .MuiOutlinedInput-root {
  border: 1px solid #00a19a !important;
  box-sizing: border-box;
  border-radius: 13px;
}
.dashboard-container .status-list-container .notes-section .MuiTextField-root {
  width: 230px;
  background: linear-gradient(180deg, #ffffff 0%, rgba(255, 255, 255, 0) 357.5%);
  border: 1px solid #ffffff;
  box-sizing: border-box;
  border-radius: 13px;
}
.dashboard-container .status-list-container .notes-section .MuiInputBase-input {
  padding: 8px 0;
}
.dashboard-container .status-list-container .notes-section .text-container {
  margin-top: 10px;
  width: 230px;
  position: relative;
}
.dashboard-container .status-list-container .notes-section .text-container .text-icon {
  position: absolute;
  right: 0;
  bottom: 0;
  padding: 10px 10px 5px 10px;
}
.dashboard-container .status-list-container .notes-section .text-container .text-icon button {
  border: none;
  background: none;
  color: #009fe3;
  cursor: pointer;
}
.dashboard-container .status-list-container .notes-section .text-container textarea {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  background: linear-gradient(180deg, #ffffff 0%, rgba(255, 255, 255, 0) 357.5%);
  border: 1px solid #ffffff;
  box-sizing: border-box;
  border-radius: 13px;
  resize: none;
  width: 100%;
  padding: 8px 12px;
}
.dashboard-container .status-list-container .notes-section .text-container textarea::placeholder {
  font-size: 10px;
}
.dashboard-container .status-list-container .notes-section .comment-box {
  font-style: normal;
  font-weight: normal;
  font-size: 10px;
  color: #ffffff;
  width: 230px;
  background: rgba(255, 255, 255, 0.3);
  box-shadow: 0px 0px 34px rgba(0, 0, 0, 0.02);
  border-radius: 10px;
  border-radius: 8px;
  margin-top: 8px;
  padding: 10px;
  justify-content: space-between;
}
.dashboard-container .status-list-container .notes-section .comment-box > div {
  display: flex;
  justify-content: space-between;
}
.dashboard-container .status-list-container .notes-section .comment-box > div:nth-child(2) {
  margin-bottom: 10px;
}
.dashboard-container .status-list-container .notes-section .comment-box p {
  margin: 0;
  word-break: break-all;
}
.dashboard-container .status-list-container .notes-section .comment-box .delete-icon button {
  border: none;
  background: none;
  color: #ffffff;
  cursor: pointer;
}
.dashboard-container .status-list-container .notes-section .notes-section-div {
  min-height: 385px;
  max-height: 450px;
  overflow: auto;
}
.dashboard-container .status-list-container .notes-section .search-comments-container {
  padding-top: 20px;
}
.dashboard-container .dashboard-top-div {
  display: flex;
  margin-left: 10px;
}
.dashboard-container .dashboard-top-div .label-class {
  background: rgba(255, 255, 255, 0.5);
  border: 2px solid #ffffff;
  box-sizing: border-box;
  border-radius: 13px;
  align-items: flex-start;
  padding: 10px 5px;
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 31px;
}
.dashboard-container .dashboard-top-div .label-class .label-value {
  font-weight: bold;
  color: #312c50;
}
.dashboard-container .dashboard-top-div .loggedIn-advisor-class {
  padding: 8px 8px 0px 8px;
  background: linear-gradient(270deg, #1e4438 -17.61%, #3a957d 95.49%);
  border-radius: 10px;
  color: #ffffff;
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 24px;
  margin-right: 10px;
  height: 50px;
  margin-top: 8px;
}
.dashboard-container .dashboard-top-div .loggedIn-advisor-class .loggedIn-advisor-name {
  font-weight: bold;
  flex: none;
  order: 0;
  flex-grow: 0;
}
.dashboard-container .chrono-container,
.dashboard-container .dashboard-summary-container {
  box-sizing: border-box;
  box-shadow: -5px 4px 34px rgba(85, 85, 85, 0.04);
  border-radius: 10px;
  margin: 5px 0px 0px 0px;
  padding: 5px 5px 0px 5px;
}
.dashboard-container .chrono-container .MuiAccordion-root,
.dashboard-container .dashboard-summary-container .MuiAccordion-root {
  position: relative;
}
.dashboard-container .chrono-container .MuiAccordionSummary-content,
.dashboard-container .dashboard-summary-container .MuiAccordionSummary-content {
  margin: 0 0 0 18px;
}
.dashboard-container .chrono-container .dashboard-charts .MuiAccordionSummary-content,
.dashboard-container .dashboard-summary-container .dashboard-charts .MuiAccordionSummary-content {
  font-size: 14px;
  font-weight: 600;
  padding-top: 6px;
  display: flex;
  justify-content: space-between;
}
.dashboard-container .chrono-container .chrono-tabs-container,
.dashboard-container .dashboard-summary-container .chrono-tabs-container {
  background: #479573;
  border: 2px solid #ffffff;
  box-sizing: border-box;
  box-shadow: -5px 4px 34px rgba(85, 85, 85, 0.04);
  border-radius: 10px;
  width: 100%;
  min-height: 50px;
  margin: 0 0px 0px 0px;
  padding: 0px;
}
.dashboard-container .chrono-container .chrono-tabs-container .chrono-list-wrapper,
.dashboard-container .dashboard-summary-container .chrono-tabs-container .chrono-list-wrapper {
  display: flex;
  list-style: none;
  color: white;
  font-size: 12px;
  padding: 0px;
}
.dashboard-container .chrono-container .chrono-tabs-container .chrono-list,
.dashboard-container .dashboard-summary-container .chrono-tabs-container .chrono-list {
  cursor: pointer;
  padding: 0px 10px;
  font-size: 12px;
  color: #ffffff;
  line-height: 14.06px;
  text-transform: uppercase;
}
.dashboard-container .chrono-container .chrono-tabs-container .chrono-list-current,
.dashboard-container .dashboard-summary-container .chrono-tabs-container .chrono-list-current {
  color: #ffffff;
  font-weight: bold;
  text-transform: uppercase;
  border-radius: 8px;
}
.dashboard-container .chrono-container .chrono-tabs-container .chrono-list-current .label,
.dashboard-container .dashboard-summary-container .chrono-tabs-container .chrono-list-current .label {
  color: #009fe3;
}
.dashboard-container .chrono-container .chrono-tabs-container .chrono-list-current .tab-heading,
.dashboard-container .dashboard-summary-container .chrono-tabs-container .chrono-list-current .tab-heading {
  border-bottom: 2px solid #ffffff;
  padding-bottom: 4px;
}
.dashboard-container .chrono-container .chrono-tabs-container .chrono-list-current .chrono-list-icon,
.dashboard-container .dashboard-summary-container .chrono-tabs-container .chrono-list-current .chrono-list-icon {
  height: 28px;
  width: 28px;
  border-radius: 50%;
  color: #e0e0e0;
  background-color: #009fe3;
}
.dashboard-container .chrono-container .chrono-tabs-wrapper,
.dashboard-container .dashboard-summary-container .chrono-tabs-wrapper {
  background: #479573;
  border: 2px solid #ffffff;
  box-sizing: border-box;
  box-shadow: -5px 4px 34px rgba(85, 85, 85, 0.04);
  border-radius: 10px;
  min-height: 62px;
  margin: 0px;
  padding: 10px;
}
.dashboard-container .chrono-container .chrono-parent-tab .MuiTabs-root,
.dashboard-container .dashboard-summary-container .chrono-parent-tab .MuiTabs-root {
  border-bottom: 1px solid #e0e0e0;
  min-height: 30px;
}
.dashboard-container .chrono-container .chrono-parent-tab .MuiTab-root,
.dashboard-container .dashboard-summary-container .chrono-parent-tab .MuiTab-root {
  font-size: 12px;
  color: white;
  min-height: 30px;
  height: 40px;
}
.dashboard-container .chrono-container .chrono-parent-tab .Mui-selected,
.dashboard-container .dashboard-summary-container .chrono-parent-tab .Mui-selected {
  font-weight: bold;
}
.dashboard-container .chrono-container .chrono-parent-tab .Mui-selected .MuiTouchRipple-root,
.dashboard-container .dashboard-summary-container .chrono-parent-tab .Mui-selected .MuiTouchRipple-root {
  border-bottom: 2px solid #ffffff;
}
.dashboard-container .chrono-container .chrono-sub-tab,
.dashboard-container .dashboard-summary-container .chrono-sub-tab {
  margin: 4px 16px;
}
.dashboard-container .chrono-container .chrono-sub-tab .MuiTab-root,
.dashboard-container .dashboard-summary-container .chrono-sub-tab .MuiTab-root {
  font-size: 10px;
  color: white;
  min-height: 30px;
  height: 40px;
}
.dashboard-container .chrono-container .chrono-sub-tab .Mui-selected,
.dashboard-container .dashboard-summary-container .chrono-sub-tab .Mui-selected {
  font-weight: bold;
}
.dashboard-container .chrono-container .chrono-sub-tab .Mui-selected .MuiTouchRipple-root,
.dashboard-container .dashboard-summary-container .chrono-sub-tab .Mui-selected .MuiTouchRipple-root {
  border-bottom: 2px solid #ffffff;
}
.dashboard-container .chrono-container .chrono-content-container,
.dashboard-container .dashboard-summary-container .chrono-content-container {
  background: rgba(255, 255, 255, 0.3);
  box-sizing: border-box;
  box-shadow: -5px 4px 34px rgba(85, 85, 85, 0.04);
  border-radius: 5px;
  min-height: 62px;
  margin: 15px 0px 10px 0px;
  padding: 10px;
}
.dashboard-container .chrono-container .chrono-content-container .chrono-list-wrapper,
.dashboard-container .dashboard-summary-container .chrono-content-container .chrono-list-wrapper {
  display: flex;
  list-style: none;
  color: white;
  font-size: 12px;
  padding: 0px;
}
.dashboard-container .chrono-container .chrono-content-container .chrono-list,
.dashboard-container .dashboard-summary-container .chrono-content-container .chrono-list {
  cursor: pointer;
  font-size: 12px;
  font-weight: bold;
  font-style: normal;
  line-height: 35px;
  color: #1e106b;
}
.dashboard-container .chrono-container .chrono-content-container .chrono-list .chrono-sub-header,
.dashboard-container .dashboard-summary-container .chrono-content-container .chrono-list .chrono-sub-header {
  margin-left: 5px;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 35px;
  color: #1e106b;
}
.dashboard-container .chrono-container .chrono-content-container .chrono-list .chrono-list-icon,
.dashboard-container .dashboard-summary-container .chrono-content-container .chrono-list .chrono-list-icon {
  height: 28px;
  width: 28px;
  border-radius: 50%;
  color: #059baf;
}
.dashboard-container .chrono-container .chrono-content-container .chrono-content-items,
.dashboard-container .dashboard-summary-container .chrono-content-container .chrono-content-items {
  align-items: center;
  list-style: none;
  padding-left: 5px;
}
.dashboard-container .chrono-container .chrono-content-container .chrono-content-items .chrono-item,
.dashboard-container .dashboard-summary-container .chrono-content-container .chrono-content-items .chrono-item {
  background: rgba(255, 255, 255, 0.5);
  box-shadow: 0px 0px 34px rgba(0, 0, 0, 0.02);
  border-radius: 10px;
  flex: none;
  order: 1;
  flex-grow: 0;
  margin: 1px 0px;
  font-weight: normal;
  font-size: 14px;
  line-height: 35px;
  color: #000000;
  padding: 2px;
}
.dashboard-container .chrono-container .chrono-content-container .chrono-content-items .chrono-item .chrono-wrapper,
.dashboard-container .dashboard-summary-container .chrono-content-container .chrono-content-items .chrono-item .chrono-wrapper {
  display: flex;
  justify-content: space-between;
}
.dashboard-container .chrono-container .chrono-content-container .chrono-content-items .chrono-item .chrono-label,
.dashboard-container .dashboard-summary-container .chrono-content-container .chrono-content-items .chrono-item .chrono-label {
  font-size: 13px;
  color: #555555;
  padding: 1px;
  margin-left: 5px;
}
.dashboard-container .chrono-container .chrono-content-container .chrono-content-items .chrono-item .chrono-value,
.dashboard-container .dashboard-summary-container .chrono-content-container .chrono-content-items .chrono-item .chrono-value {
  font-size: 13px;
  color: black;
  justify-content: flex-end;
  margin-right: 8px;
}
.dashboard-container .chrono-container .chrono-content-container .chrono-content-items .chrono-item .chrono-label-no-tooltip,
.dashboard-container .dashboard-summary-container .chrono-content-container .chrono-content-items .chrono-item .chrono-label-no-tooltip {
  padding: 1px;
  font-size: 13px;
  color: #555555;
}
.dashboard-container .chrono-container .chrono-content-container .chrono-content-items .chrono-item .chrono-label-no-tooltip:hover,
.dashboard-container .dashboard-summary-container .chrono-content-container .chrono-content-items .chrono-item .chrono-label-no-tooltip:hover {
  background: rgba(203, 249, 255, 0.5);
  border: 1px dashed #009fe3;
  box-sizing: border-box;
  box-shadow: 0px 0px 23px rgba(2, 209, 255, 0.3);
  border-radius: 2px 10px 10px 10px;
}
.dashboard-container .chrono-wrapper {
  max-height: 580px;
  overflow-y: auto;
  padding: 0px 5px 5px 5px;
}
.dashboard-container .dashboard-summary-container .chrono-content-container {
  border: none;
  padding: 10px;
}
.dashboard-container .dashboard-summary-container .chrono-content-container .chrono-list {
  margin-bottom: 10px;
  cursor: default;
}
.dashboard-container .popover-container .popover-item:hover {
  background: rgba(203, 249, 255, 0.5);
  border: 1px dashed #009fe3;
  box-sizing: border-box;
  box-shadow: 0px 0px 23px rgba(2, 209, 255, 0.3);
  border-radius: 2px 10px 10px 10px;
}
.dashboard-container .popover-container .chrono-list-wrapper {
  display: flex;
  list-style: none;
  color: white;
  font-size: 12px;
  padding: 0px;
}
.dashboard-container .popover-container .chrono-list {
  cursor: pointer;
  padding: 0px 15px;
  font-size: 12px;
  font-weight: bold;
  font-style: normal;
  text-transform: capitalize;
  line-height: 35px;
  color: #1e106b;
}
.dashboard-container .popover-container .chrono-list .chrono-sub-header {
  margin-left: 5px;
}
.dashboard-container .popover-container .chrono-content-items {
  align-items: center;
  list-style: none;
  padding-left: 5px;
}
.dashboard-container .popover-container .chrono-content-items .chrono-item {
  background: rgba(255, 255, 255, 0.5);
  box-shadow: 0px 0px 34px rgba(0, 0, 0, 0.02);
  border-radius: 10px;
  flex: none;
  order: 1;
  flex-grow: 0;
  margin: 1px 0px;
  font-weight: normal;
  font-size: 14px;
  line-height: 35px;
  color: #000000;
  padding: 2px;
}
.dashboard-container .popover-container .chrono-content-items .chrono-item .chrono-label {
  font-size: 13px;
  color: #555555;
  padding: 2px;
  margin-left: 5px;
}
.dashboard-container .popover-container .chrono-content-items .chrono-item .chrono-value {
  font-size: 13px;
  color: black;
  justify-content: flex-end;
}

.client-dashboard-title {
  display: grid;
  grid-template-columns: 2fr 3fr 2fr;
  grid-template-rows: 50px;
  font-size: 18px;
  font-weight: 400;
}

.client-dashboard-fields,
.add-new-plan-fields {
  grid-template-columns: 0.1fr 3fr 0.1fr;
  grid-template-rows: 50px;
}
.client-dashboard-fields .client-dropdown,
.add-new-plan-fields .client-dropdown {
  width: 100%;
  padding: 10px;
}
.client-dashboard-fields .plan-dropdown,
.add-new-plan-fields .plan-dropdown {
  width: 100%;
  padding: 10px;
}
.client-dashboard-fields .plan-name-field,
.add-new-plan-fields .plan-name-field {
  width: 100%;
  padding: 5px;
}

.planner-container .faq-container {
  box-sizing: border-box;
  box-shadow: -5px 4px 34px rgba(85, 85, 85, 0.04);
  border-radius: 5px;
  padding: 5px;
}
.planner-container .faq-container .faq-content-items .faq-item {
  background: rgba(255, 255, 255, 0.5);
  box-shadow: 0px 0px 34px rgba(0, 0, 0, 0.02);
  border-radius: 10px;
  flex: none;
  order: 1;
  flex-grow: 0;
  margin: 1px 0px;
  font-weight: normal;
  font-size: 14px;
  line-height: 25px;
  color: #000000;
  padding: 2px;
}
.planner-container .faq-container .faq-content-items .faq-item .faq-question {
  font-size: 13px;
  color: #555555;
}
.planner-container .faq-container .faq-content-items .faq-item .faq-answer {
  font-size: 13px;
  color: black;
}

.dashboard-planner-fields .field-item {
  height: 45px;
}
.dashboard-planner-fields .field-label {
  font-size: 12px;
  padding: 10px;
  border-right: 1px solid #ffffff;
}
.dashboard-planner-fields .field-member {
  height: 35px;
  border-right: 1px solid #ffffff;
  text-align: center;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: bold;
  padding: 10px;
}
.dashboard-planner-fields .planner-input-grid {
  box-sizing: border-box;
  text-align: center;
}
.dashboard-planner-fields .planner-input-grid:last-child {
  border-right: 1px solid #ffffff;
}
.dashboard-planner-fields .planner-input-grid > div {
  border-radius: 10px;
}
.dashboard-planner-fields .planner-input-grid .error-text {
  padding: 0;
  margin: 0;
  font-size: 10px;
  color: red;
}
.dashboard-planner-fields .planner-input-grid .error-field {
  border-color: red;
}
.dashboard-planner-fields .planner-input-grid .input-value {
  border-radius: 45px 50px 5px 50px;
  color: #000;
  padding: 5px 5px;
  background: linear-gradient(270deg, #41b6c4 -17.61%, #7fcdbb 95.49%);
  font-size: 11px;
  text-align: center;
  margin-top: 8px;
  margin-right: 5px;
  margin-bottom: 5px;
  display: inline;
}
.dashboard-planner-fields .member-field-disabled {
  background-color: lightgray;
}
.dashboard-planner-fields .planner-input {
  border-radius: 8px;
  border: 0.5px solid #61b76e;
  width: 100%;
  height: 30px;
  padding: 4px;
}
.dashboard-planner-fields .planner-input:focus-visible {
  outline: none;
}
.dashboard-planner-fields .planner-input-hide {
  opacity: 0;
  height: 0;
  width: 0;
}
.dashboard-planner-fields .planner-input-show {
  opacity: 1;
  transition: all 0.3s ease-out;
  -webkit-transition: all 0.3s ease-out;
}
.dashboard-planner-fields .planner-input-show svg {
  vertical-align: middle;
}
.dashboard-planner-fields .planner-input-show .select {
  width: 80%;
  border-color: #61b76e;
  border-radius: 8px;
  padding: 4px 0;
}
.dashboard-planner-fields .row-wrapper {
  border-top: 1px solid #ffffff;
  border-left: 1px solid #ffffff;
  border-bottom: 1px solid #ffffff;
}

.goals-answer-container {
  padding: 0px !important;
}
.goals-answer-container .chrono-wrapper {
  padding: 0 5px 0;
  border-radius: 0;
}
.goals-answer-container .goals-label:nth-child(2) {
  border-left: 2px solid #fff;
  border-right: 2px solid #fff;
}

.MuiPickersBasePicker-container .MuiPickersToolbar-toolbar {
  background: linear-gradient(180deg, #6ccea6 0%, #16899d 100%) rgba(255, 255, 255, 0.75);
  height: 70px;
}
.MuiPickersBasePicker-container .MuiTypography-colorPrimary {
  color: rgba(56, 211, 100, 0.75) !important;
}
.MuiPickersBasePicker-container .MuiTypography-h3 {
  font-size: 2rem;
}`, "",{"version":3,"sources":["webpack://./src/styles/retirementPlan.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,oCAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EAEA,6BAAA;AAAF;AAEE;EACE,gBAAA;AAAJ;AAEI;EACE,iBAAA;EACA,aAAA;EACA,mGAAA;EAGA,yBAAA;EACA,sBAAA;EACA,mBAAA;AAFN;AAIM;EAaE,aAAA;AAdR;AAEQ;EAOE,aAAA;EACA,kCAAA;EACA,wBAAA;AANV;AAFU;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAIZ;AAMQ;EACE,kBAAA;EACA,iBAAA;EACA,2CAAA;EACA,eAAA;EACA,uBAAA;EACA,cAAA;EACA,yBAAA;AAJV;AAOQ;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;AALV;AAUQ;EACE,WAAA;EACA,YAAA;AARV;AAWQ;EACE,WAAA;EACA,YAAA;AATV;AAaM;EACE,iBAAA;EACA,aAAA;EACA,uBAAA;AAXR;AAaQ;;EAEE,eAAA;EACA,qFAAA;EAGA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;AAbV;AAeU;;EACE,YAAA;EACA,cAAA;AAZZ;AAeU;;EACE,2BAAA;AAZZ;AAeU;;;;EAEE,qFAAA;AAXZ;AAkBM;EACE,uBAAA;EACA,aAAA;AAhBR;AAkBQ;EACE,eAAA;EACA,oBAAA;EACA,0BAAA;AAhBV;AAsBM;EACE,WAAA;EACA,WAAA;AApBR;AAuBM;EACE;IACE,eAAA;IACA,gBAAA;EArBR;AACF;AAwBM;EACE;IACE,gBAAA;IACA,iBAAA;EAtBR;AACF;AAyBM;EACE;IACE,gBAAA;IACA,iBAAA;EAvBR;AACF;AA0BM;EACE;IACE,gBAAA;IACA,iBAAA;EAxBR;AACF;AA2BM;EACE,mBAAA;EACA,YAAA;EACA,aAAA;EACA,oEAAA;EACA,yBAAA;EACA,sBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,sCAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AAzBR;AA6BI;EACE,iBAAA;EACA,aAAA;EACA,mGAAA;EAGA,mBAAA;AA7BN;AA+BM;EACE,aAAA;EACA,kCAAA;EACA,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AA7BR;AAiCQ;EACE,WAAA;EACA,aAAA;AA/BV;AAkCQ;EACE,WAAA;EACA,aAAA;AAhCV;AAoCM;EACE,aAAA;EACA,UAAA;AAlCR;AAoCQ;EACE,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;AAlCV;AAoCU;EACE,YAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;AAlCZ;AAqCU;EACE,2BAAA;AAnCZ;AA0CE;EACE,kBAAA;EACA,sBAAA;EACA,gBAAA;AAxCJ;AA0CI;EACE,6CAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;AAxCN;AA0CM;EACE,SAAA;AAxCR;AA2CM;EACE,eAAA;AAzCR;AA8CE;EACE,aAAA;EACA,iBAAA;AA5CJ;AA8CI;EACE,WAAA;AA5CN;AAiDE;EACE,gBAAA;AA/CJ;AAiDI;EACE,iBAAA;AA/CN;AAiDM;EACE,iBAAA;EACA,cAAA;AA/CR;AAqDI;EACE,YAAA;EACA,WAAA;AAnDN;AAsDI;EACE,0CAAA;AApDN;AAyDI;EAME,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;AA5DN;AAmDM;EACE,eAAA;EACA,gBAAA;AAjDR;AA2DI;EACE,sBAAA;AAzDN;AA2DM;EACE,yBAAA;EACA,kBAAA;EACA,YAAA;AAzDR;AA2DQ;EACE,SAAA;AAzDV;AA4DQ;EACE,eAAA;AA1DV;;AAiEA;EACE,gCAAA;EACA,aAAA;EACA,qBAAA;EACA,8BAAA;AA9DF;AAgEE;EACE,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,oBAAA;EACA,cAAA;AA9DJ;AAiEE;EACE,cAAA;EACA,WAAA;EACA,eAAA;AA/DJ;;AAmEA;EACE,iBAAA;AAhEF;AAkEE;EAeE,aAAA;EACA,gBAAA;AA9EJ;AAiEQ;EACE,WAAA;AA/DV;AAoEQ;EACE,WAAA;AAlEV;AA2EE;EAeE,aAAA;EACA,gBAAA;AAvFJ;AA0EQ;EACE,cAAA;AAxEV;AA6EQ;EACE,cAAA;AA3EV;;AAqFA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;AAlFF;;AAsFE;EACE,sBAAA;AAnFJ;;AAuFA;EACE,gBAAA;AApFF;AAsFE;EACE,YAAA;AApFJ;AAuFE;EACE,kBAAA;EACA,sBAAA;AArFJ;AAuFI;EACE,yBAAA;EACA,oBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AArFN;AAuFM;EACE,SAAA;AArFR;AAwFM;EACE,iBAAA;AAtFR;AA2FE;EACE,iBAAA;EACA,YAAA;AAzFJ;AA2FI;EACE,WAAA;EACA,qEAAA;EACA,kBAAA;AAzFN;AA4FI;EACE,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;AA1FN;AA6FI;EACE,gBAAA;EACA,eAAA;EACA,YAAA;EACA,uBAAA;AA3FN;AA6FM;EACE,cAAA;EACA,cAAA;EACA,qBAAA;EACA,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;AA3FR;AA6FQ;EACE,mBAAA;EACA,2CAAA;EACA,mBAAA;EACA,cAAA;AA3FV;AA8FQ;EACE,oBAAA;AA5FV;AAkGE;EACE,yBAAA;AAhGJ;AAmGE;EACE,aAAA;AAjGJ;AAoGE;EACE,eAAA;AAlGJ;AAqGE;EACE,gBAAA;EACA,YAAA;EACA,6BAAA;AAnGJ;AAqGI;EACE,6BAAA;AAnGN;AAuGE;EACE,iBAAA;EACA,gBAAA;EACA,YAAA;AArGJ;AAwGE;EACE,kBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;AAtGJ;AAwGI;EACE,kBAAA;EACA,iBAAA;EACA,2CAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,iBAAA;AAtGN;AAyGI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AAvGN;AA0GI;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;AAxGN;;AA6GA;EACE,kBAAA;AA1GF;;AA8GE;EACE,kBAAA;EA8BA,aAAA;AAxIJ;AA4GI;EACE,2BAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;AA1GN;AA6GI;EACE,kBAAA;EACA,SAAA;AA3GN;AA+GM;EACE,aAAA;AA7GR;AAgHM;EACE,UAAA;AA9GR;AAiHM;EACE,iBAAA;EACA,cAAA;EACA,yBAAA;AA/GR;AAqHI;EACE,cAAA;EACA,iBAAA;EACA,WAAA;EACA,aAAA;AAnHN;AAqHM;EACE,YAAA;AAnHR;AAuHI;EACE,oCAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;AArHN;AAuHM;EACE,UAAA;EACA,kBAAA;EACA,aAAA;AArHR;AAwHM;;EAEE,UAAA;EACA,UAAA;EACA,sBAAA;AAtHR;AAyHM;EACE,YAAA;AAvHR;AA0HM;EACE,eAAA;AAxHR;AAgII;EACE,gBAAA;AA9HN;AAiII;EACE,aAAA;EACA,8BAAA;EAEA,iBAAA;EACA,cAAA;AAhIN;AAkIM;EACE,iBAAA;AAhIR;AAmIM;EACE,iBAAA;EACA,cAAA;EACA,yBAAA;EACA,eAAA;EACA,cAAA;EAEA,yBAAA;EACA,aAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;AAlIR;;AAwIA;EACE,gBAAA;AArIF;;AAwIA;EACE,cAAA;AArIF;;AAwIA;EACE,aAAA;AArIF;;AAwIA;EACE,qBAAA;AArIF;;AAwIA;EACE,qBAAA;AArIF;;AAwIA;EACE,qBAAA;AArIF;;AAwIA;EACE,0BAAA;AArIF;;AAwIA;EAEE,0BAAA;AAtIF;AAwIE;;;;;EAKE,eAAA;AAtIJ;AAyIE;EACE,+EAAA;AAvIJ;AA6II;EACE,YAAA;EACA,aAAA;AA3IN;AA+IE;EACE,0BAAA;EACA,eAAA;AA7IJ;AA+II;EACE,YAAA;EACA,aAAA;AA7IN;AAgJI;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,oEAAA;EACA,yBAAA;EACA,sBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,sCAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AA9IN;AAiJI;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,sCAAA;EACA,iBAAA;EACA,YAAA;EACA,eAAA;AA/IN;AAkJI;EACE,qBAAA;EACA,sBAAA;AAhJN;AAmJI;EACE,eAAA;EACA,YAAA;EACA,mBAAA;AAjJN;AAqJE;EACE,sBAAA;EACA,wBAAA;AAnJJ;AAsJE;EAYE,0BAAA;EACA,UAAA;AA/JJ;AAmJI;EACE,gBAAA;AAjJN;AAuJI;EACE,cAAA;AArJN;AA2JI;EACE,oCAAA;EAEA,sBAAA;EACA,gDAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,aAAA;AA1JN;AA4JM;EACE,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AA1JR;AA+JE;EAEE,mBAAA;EACA,UAAA;EACA,mBAAA;EACA,0BAAA;EACA,0BAAA;AA9JJ;AAgKI;EACE,iBAAA;EACA,iBAAA;EACA,cAAA;AA9JN;AAiKI;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;AA/JN;AAkKI;EACE,eAAA;EACA,iBAAA;AAhKN;AAkKM;EACE,qCAAA;EACA,0CAAA;EACA,sBAAA;EACA,kBAAA;AAhKR;AAkKQ;EACE,YAAA;AAhKV;AAmKQ;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAjKV;AAsKI;EACE,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;AApKN;AAuKI;EACE,8BAAA;EACA,qBAAA;AArKN;AA4KQ;EACE,eAAA;AA1KV;AA6KQ;EACE,oCAAA;EACA,sBAAA;EACA,mBAAA;AA3KV;AA+KM;EACE,YAAA;EACA,8EAAA;EAGA,yBAAA;EACA,sBAAA;EACA,mBAAA;AA/KR;AAkLM;EACE,cAAA;AAhLR;AAmLM;EACE,gBAAA;EACA,YAAA;EACA,kBAAA;AAjLR;AAmLQ;EAQE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,2BAAA;AAxLV;AA8KU;EACE,YAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AA5KZ;AAqLQ;EAKE,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,8EAAA;EAGA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;AAzLV;AAyKU;EACE,eAAA;AAvKZ;AA0LM;EACE,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,oCAAA;EACA,4CAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,8BAAA;AAxLR;AA0LQ;EACE,aAAA;EACA,8BAAA;AAxLV;AA2LQ;EACE,mBAAA;AAzLV;AA4LQ;EACE,SAAA;EACA,qBAAA;AA1LV;AA8LU;EACE,YAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AA5LZ;AAiMM;EACE,iBAAA;EACA,iBAAA;EACA,cAAA;AA/LR;AAkMM;EACE,iBAAA;AAhMR;AAqME;EACE,aAAA;EACA,iBAAA;AAnMJ;AAqMI;EACE,oCAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAnMN;AAqMM;EACE,iBAAA;EACA,cAAA;AAnMR;AAuMI;EACE,wBAAA;EACA,oEAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AArMN;AAuMM;EACE,iBAAA;EACA,UAAA;EACA,QAAA;EACA,YAAA;AArMR;AA0ME;;EA4OE,sBAAA;EACA,gDAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;AAlbJ;AAoMI;;EACE,kBAAA;AAjMN;AAyMI;;EACE,kBAAA;AAtMN;AA0MM;;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;AAvMR;AA2MI;;EAEE,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,gDAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,qBAAA;EACA,YAAA;AAzMN;AA2MM;;EACE,aAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;AAxMR;AA2MM;;EACE,eAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;EACA,yBAAA;AAxMR;AA0MQ;;EACE,cAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;AAvMV;AAyMU;;EACE,cAAA;AAtMZ;AAyMU;;EACE,gCAAA;EACA,mBAAA;AAtMZ;AAyMU;;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;AAtMZ;AA4MI;;EAEE,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,gDAAA;EACA,mBAAA;EAEA,gBAAA;EACA,WAAA;EACA,aAAA;AA3MN;AA+MM;;EACE,gCAAA;EACA,gBAAA;AA5MR;AA+MM;;EACE,eAAA;EAEA,YAAA;EACA,gBAAA;EACA,YAAA;AA7MR;AAgNM;;EACE,iBAAA;AA7MR;AA+MQ;;EACE,gCAAA;AA5MV;AAiNI;;EACE,gBAAA;AA9MN;AAgNM;;EACE,eAAA;EAEA,YAAA;EACA,gBAAA;EACA,YAAA;AA9MR;AAiNM;;EACE,iBAAA;AA9MR;AAgNQ;;EACE,gCAAA;AA7MV;AAkNI;;EACE,oCAAA;EAEA,sBAAA;EACA,gDAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,aAAA;AAhNN;AAkNM;;EACE,aAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;AA/MR;AAkNM;;EACE,eAAA;EAEA,eAAA;EACA,iBAAA;EACA,kBAAA;EAEA,iBAAA;EACA,cAAA;AAjNR;AAmNQ;;EACE,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAhNV;AAmNQ;;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;AAhNV;AAoNM;;EACE,mBAAA;EACA,gBAAA;EACA,iBAAA;AAjNR;AAmNQ;;EACE,oCAAA;EACA,4CAAA;EACA,mBAAA;EACA,UAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;AAhNV;AAkNU;;EACE,aAAA;EACA,8BAAA;AA/MZ;AAkNU;;EACE,eAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;AA/MZ;AAkNU;;EACE,eAAA;EACA,YAAA;EACA,yBAAA;EACA,iBAAA;AA/MZ;AAkNU;;EACE,YAAA;EACA,eAAA;EACA,cAAA;AA/MZ;AAiNY;;EACE,oCAAA;EACA,0BAAA;EACA,sBAAA;EACA,+CAAA;EACA,iCAAA;AA9Md;AA6NE;EACE,iBAAA;EACA,gBAAA;EACA,wBAAA;AA3NJ;AAgOI;EACE,YAAA;EACA,aAAA;AA9NN;AAgOM;EACE,mBAAA;EACA,eAAA;AA9NR;AAqOM;EACE,oCAAA;EACA,0BAAA;EACA,sBAAA;EACA,+CAAA;EACA,iCAAA;AAnOR;AAuOI;EACE,aAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;AArON;AAwOI;EACE,eAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,0BAAA;EACA,iBAAA;EACA,cAAA;AAtON;AAwOM;EACE,gBAAA;AAtOR;AA0OI;EACE,mBAAA;EACA,gBAAA;EACA,iBAAA;AAxON;AA0OM;EACE,oCAAA;EACA,4CAAA;EACA,mBAAA;EACA,UAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;AAxOR;AA0OQ;EACE,eAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;AAxOV;AA2OQ;EACE,eAAA;EACA,YAAA;EACA,yBAAA;AAzOV;;AAgPA;EACE,aAAA;EACA,kCAAA;EACA,wBAAA;EACA,eAAA;EACA,gBAAA;AA7OF;;AAgPA;;EAGE,sCAAA;EACA,wBAAA;AA9OF;AAgPE;;EACE,WAAA;EACA,aAAA;AA7OJ;AAgPE;;EACE,WAAA;EACA,aAAA;AA7OJ;AAgPE;;EACE,WAAA;EACA,YAAA;AA7OJ;;AAkPE;EACE,sBAAA;EACA,gDAAA;EACA,kBAAA;EACA,YAAA;AA/OJ;AAkPM;EACE,oCAAA;EACA,4CAAA;EACA,mBAAA;EACA,UAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;AAhPR;AAkPQ;EACE,eAAA;EACA,cAAA;AAhPV;AAmPQ;EACE,eAAA;EACA,YAAA;AAjPV;;AAyPE;EAKE,YAAA;AA1PJ;AA6PE;EACE,eAAA;EACA,aAAA;EAEA,+BAAA;AA5PJ;AA+PE;EACE,YAAA;EACA,+BAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;AA7PJ;AAgQE;EACE,sBAAA;EAEA,kBAAA;AA/PJ;AAkQI;EACE,+BAAA;AAhQN;AAmQI;EAGE,mBAAA;AAnQN;AAsQI;EACE,UAAA;EACA,SAAA;EACA,eAAA;EACA,UAAA;AApQN;AAuQI;EACE,iBAAA;AArQN;AAyQI;EACE,iCAAA;EACA,WAAA;EACA,gBAAA;EAEA,oEAAA;EAEA,eAAA;EAEA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AA1QN;AA8QE;EACE,2BAAA;AA5QJ;AAgRI;EACE,kBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AA9QN;AAgRM;EACE,aAAA;AA9QR;AAiRM;EACE,UAAA;EACA,SAAA;EACA,QAAA;AA/QR;AAkRM;EACE,UAAA;EAEA,6BAAA;EACA,qCAAA;AAjRR;AAoRQ;EACE,sBAAA;AAlRV;AAqRQ;EACE,UAAA;EACA,qBAAA;EACA,kBAAA;EACA,cAAA;AAnRV;AAyRE;EACE,6BAAA;EACA,8BAAA;EACA,gCAAA;AAvRJ;;AA2RA;EACE,uBAAA;AAxRF;AA0RE;EACE,gBAAA;EACA,gBAAA;AAxRJ;AA4RI;EACE,2BAAA;EACA,4BAAA;AA1RN;;AAgSE;EACE,uFAAA;EACA,YAAA;AA7RJ;AAgSE;EACE,0CAAA;AA9RJ;AAiSE;EACE,eAAA;AA/RJ","sourcesContent":[".retirement-plan-container {\r\n  min-height: 100vh;\r\n  /* will cover the 100% of viewport */\r\n  background-color: #e0e0e0;\r\n  position: relative;\r\n  display: block;\r\n  // font-family: 'Roboto' !important;\r\n  font-style: normal !important;\r\n\r\n  .login-container {\r\n    min-height: 90vh;\r\n\r\n    .login {\r\n      margin-top: 150px;\r\n      height: 350px;\r\n      background: linear-gradient(180deg,\r\n          rgba(255, 255, 255, 0.6) 11.97%,\r\n          rgba(255, 255, 255, 0) 77.22%);\r\n      border: 2px solid #ffffff;\r\n      box-sizing: border-box;\r\n      border-radius: 83px;\r\n\r\n      .login-title-wrapper {\r\n        .lcontainer {\r\n          .logo>img {\r\n            width: 70px;\r\n            height: 70px;\r\n            object-fit: cover;\r\n          }\r\n\r\n          display: grid;\r\n          grid-template-columns: 1fr 1fr 2fr;\r\n          grid-template-rows: 50px;\r\n        }\r\n\r\n        padding: 30px;\r\n\r\n        .logo-class {\r\n          font-style: normal;\r\n          font-weight: bold;\r\n          font-family: 'Noto Sans', Arial, sans-serif;\r\n          font-size: 30px;\r\n          letter-spacing: -0.08em;\r\n          color: #059baf;\r\n          padding: 15px 0px 0px 0px;\r\n        }\r\n\r\n        .logo-tagline-class {\r\n          font-size: 10px;\r\n          color: #009fe3;\r\n          font-weight: 700;\r\n          padding: 35px 0px 0px 5px;\r\n        }\r\n      }\r\n\r\n      .login-fields {\r\n        .user-email-field {\r\n          width: 100%;\r\n          padding: 5px;\r\n        }\r\n\r\n        .user-password-field {\r\n          width: 100%;\r\n          padding: 5px;\r\n        }\r\n      }\r\n\r\n      .login-buttons {\r\n        padding: 10px 0 0;\r\n        display: flex;\r\n        justify-content: center;\r\n\r\n        .sign-in-button,\r\n        .sign-up-button {\r\n          font-size: 12px;\r\n          background: radial-gradient(58.52% 47.51% at 56.65% 47.58%,\r\n              #059baf 0%,\r\n              #007080 100%);\r\n          border: 2px solid #ffffff;\r\n          border-radius: 9px;\r\n          padding: 2px;\r\n          margin: 10px;\r\n\r\n          .MuiButton-root {\r\n            padding: 0px;\r\n            color: #ffffff;\r\n          }\r\n\r\n          .MuiButton-contained {\r\n            box-shadow: none !important;\r\n          }\r\n\r\n          .MuiButton-containedPrimary,\r\n          .MuiButton-containedPrimary:hover {\r\n            background: radial-gradient(58.52% 47.51% at 56.65% 47.58%,\r\n                #059baf 0%,\r\n                #007080 100%);\r\n          }\r\n        }\r\n      }\r\n\r\n      .forgot-pwd-container {\r\n        justify-content: center;\r\n        display: flex;\r\n\r\n        .forgot-pwd-button {\r\n          cursor: pointer;\r\n          text-transform: none;\r\n          text-decoration: underline;\r\n        }\r\n      }\r\n    }\r\n\r\n    .chart-container {\r\n      .chart-div {\r\n        width: 100%;\r\n        height: 75%;\r\n      }\r\n\r\n      @media (max-width: 767px) {\r\n        .chart-div {\r\n          max-width: 100%;\r\n          max-height: 100%;\r\n        }\r\n      }\r\n\r\n      @media (min-width: 768px) {\r\n        .chart-div {\r\n          max-width: 400px;\r\n          max-height: 450px;\r\n        }\r\n      }\r\n\r\n      @media (min-width: 992px) {\r\n        .chart-div {\r\n          max-width: 450px;\r\n          max-height: 450px;\r\n        }\r\n      }\r\n\r\n      @media (min-width: 1200px) {\r\n        .chart-div {\r\n          max-width: 500px;\r\n          max-height: 500px;\r\n        }\r\n      }\r\n\r\n      .inner-radius {\r\n        border-radius: 80px;\r\n        width: 125px;\r\n        height: 125px;\r\n        background: linear-gradient(92.79deg, #009fe3 6.52%, #00a19a 71.42%);\r\n        border: 1px solid #ffffff;\r\n        box-sizing: border-box;\r\n        top: 238px;\r\n        left: 287px;\r\n        text-align: center;\r\n        vertical-align: middle;\r\n        position: absolute;\r\n        box-shadow: 0 0 10px 1px #ffffff inset;\r\n        padding-top: 50px;\r\n        color: #ffffff;\r\n        font-size: 12px;\r\n      }\r\n    }\r\n\r\n    .login-client-container {\r\n      margin-top: 200px;\r\n      height: 250px;\r\n      background: linear-gradient(270deg,\r\n          rgba(255, 255, 255, 0.7) 38.89%,\r\n          rgba(255, 255, 255, 0) 91.66%);\r\n      border-radius: 83px;\r\n\r\n      .client-login-dashboard-title {\r\n        display: grid;\r\n        grid-template-columns: 2fr 3fr 2fr;\r\n        grid-template-rows: 50px;\r\n        margin-top: 30px;\r\n        font-size: 18px;\r\n        font-weight: 400;\r\n      }\r\n\r\n      .client-login-fields {\r\n        .client-dropdown {\r\n          width: 100%;\r\n          padding: 10px;\r\n        }\r\n\r\n        .plan-dropdown {\r\n          width: 100%;\r\n          padding: 10px;\r\n        }\r\n      }\r\n\r\n      .client-dashboard-button-container {\r\n        padding: 10px;\r\n        width: 50%;\r\n\r\n        .client-goto-dashboard-button {\r\n          background: #1890ff;\r\n          border-radius: 9px;\r\n          height: auto;\r\n          padding: 5px;\r\n          text-align: center;\r\n          position: relative;\r\n          left: 50%;\r\n\r\n          .MuiButton-root {\r\n            padding: 0px;\r\n            color: #ffffff;\r\n            font-size: 14px;\r\n            font-weight: 400;\r\n            text-transform: none;\r\n          }\r\n\r\n          .MuiButton-contained {\r\n            box-shadow: none !important;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .simulate-buttons {\r\n    padding: 2px 2px 0;\r\n    max-width: fit-content;\r\n    margin-top: 10px;\r\n\r\n    button {\r\n      background-color: rgb(34, 94, 168) !important;\r\n      color: #fff;\r\n      padding: 4px;\r\n      border-radius: 5px;\r\n      height: 30px;\r\n\r\n      .MuiButton-startIcon {\r\n        margin: 0;\r\n      }\r\n\r\n      .MuiButton-iconSizeMedium {\r\n        margin-right: 0;\r\n      }\r\n    }\r\n  }\r\n\r\n  .review-form-grid {\r\n    margin: 0 4px;\r\n    padding-top: 16px;\r\n\r\n    .MuiFormControl-root {\r\n      width: 100%;\r\n      // margin: 8px;\r\n    }\r\n  }\r\n\r\n  .page-header {\r\n    padding-top: 8px;\r\n\r\n    .page-title {\r\n      padding-left: 8px;\r\n\r\n      .sub-title {\r\n        font-weight: bold;\r\n        color: #89c5d3;\r\n      }\r\n    }\r\n  }\r\n\r\n  .avatar {\r\n    .MuiAvatar-root {\r\n      height: 30px;\r\n      width: 30px;\r\n    }\r\n\r\n    .MuiAvatar-colorDefault {\r\n      background-color: rgba(255, 255, 255, 0.4);\r\n    }\r\n  }\r\n\r\n  .cta-container {\r\n    .cta-header {\r\n      .MuiTypography-root {\r\n        font-size: 14px;\r\n        font-weight: 600;\r\n      }\r\n\r\n      border-radius: 4px;\r\n      text-align: center;\r\n      margin-bottom: 5px;\r\n      padding: 5px;\r\n      color: #ffffff;\r\n    }\r\n\r\n    .cta-buttons {\r\n      max-width: fit-content;\r\n\r\n      button {\r\n        background-color: #009fe3;\r\n        border-radius: 8px;\r\n        height: 25px;\r\n\r\n        .MuiButton-startIcon {\r\n          margin: 0;\r\n        }\r\n\r\n        .MuiButton-iconSizeMedium {\r\n          margin-right: 0;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.signup-title-container {\r\n  border-bottom: 1px solid #cccccc;\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  justify-content: space-between;\r\n\r\n  .signup-title {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    display: inline-block;\r\n    padding-bottom: 10px;\r\n    color: #3e9479;\r\n  }\r\n\r\n  .signup-title-close-icon {\r\n    color: #666666;\r\n    right: 25px;\r\n    font-size: 14px;\r\n  }\r\n}\r\n\r\n.signup-body-container {\r\n  padding-top: 12px;\r\n\r\n  .signup-form-grid {\r\n    .controls {\r\n      &-input {\r\n        label {\r\n          color: #fff;\r\n        }\r\n      }\r\n\r\n      &-select {\r\n        label {\r\n          color: #fff;\r\n        }\r\n      }\r\n    }\r\n\r\n    margin: 0 4px;\r\n    padding-top: 5px;\r\n  }\r\n\r\n  .newplan-form-grid {\r\n    .controls {\r\n      &-input {\r\n        label {\r\n          color: #666666;\r\n        }\r\n      }\r\n\r\n      &-select {\r\n        label {\r\n          color: #666666;\r\n        }\r\n      }\r\n    }\r\n\r\n    margin: 0 4px;\r\n    padding-top: 5px;\r\n  }\r\n}\r\n\r\n.signup-loader {\r\n  position: absolute;\r\n  top: 50%;\r\n  z-index: 1;\r\n  left: 50%;\r\n}\r\n\r\n.direct-user-header {\r\n  .MuiPaper-root {\r\n    width: 100% !important;\r\n  }\r\n}\r\n\r\n.header-container {\r\n  min-height: 94vh;\r\n\r\n  .body-container {\r\n    margin: 10px;\r\n  }\r\n\r\n  .feedback-button {\r\n    padding: 4px 2px 0;\r\n    max-width: fit-content;\r\n\r\n    button {\r\n      background-color: #fbc02d;\r\n      text-transform: none;\r\n      padding: 5px;\r\n      border-radius: 4px;\r\n      height: 25px;\r\n      font-weight: bold;\r\n\r\n      .MuiButton-startIcon {\r\n        margin: 0;\r\n      }\r\n\r\n      .MuiButton-iconSizeMedium {\r\n        margin-right: 4px;\r\n      }\r\n    }\r\n  }\r\n\r\n  .side-drawer {\r\n    padding-top: 10px;\r\n    height: 100%;\r\n\r\n    .MuiDrawer-paper {\r\n      width: 63px;\r\n      background: linear-gradient(180.61deg, #00a19a 9.35%, #009fe3 106.9%);\r\n      overflow-x: hidden;\r\n    }\r\n\r\n    .greenr-logo {\r\n      background-color: #fff;\r\n      margin-left: -14px; //check with Bhargavi on this\r\n      height: 30px;\r\n      min-height: 50px;\r\n    }\r\n\r\n    .side-nav-list {\r\n      list-style: none;\r\n      font-size: 11px;\r\n      padding: 2px;\r\n      justify-content: center;\r\n\r\n      .list-item {\r\n        color: #ffffff;\r\n        display: block;\r\n        text-decoration: none;\r\n        text-align: -webkit-center;\r\n        cursor: pointer;\r\n        margin-bottom: 20px;\r\n        line-height: 20px;\r\n\r\n        &-current {\r\n          background: #f8f8f8;\r\n          box-shadow: 0px 4px 9px rgba(0, 0, 0, 0.35);\r\n          border-radius: 10px;\r\n          color: #009fe3;\r\n        }\r\n\r\n        .list-item-icon {\r\n          margin: 10px 0 0 0px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .appbar-bg {\r\n    background-color: #288693;\r\n  }\r\n\r\n  .header-name {\r\n    margin: 0 5px;\r\n  }\r\n\r\n  .header-tag {\r\n    font-size: 1rem;\r\n  }\r\n\r\n  .header-btn {\r\n    box-shadow: none;\r\n    border: none;\r\n    background-color: transparent;\r\n\r\n    &:hover {\r\n      background-color: transparent;\r\n    }\r\n  }\r\n\r\n  .logo-container {\r\n    padding-left: 5px;\r\n    min-height: 50px;\r\n    height: 30px;\r\n  }\r\n\r\n  .header-logo {\r\n    font-style: normal;\r\n    color: #ffffff;\r\n    display: inline-flex;\r\n    align-items: center;\r\n\r\n    .logo-class {\r\n      font-style: normal;\r\n      font-weight: bold;\r\n      font-family: 'Noto Sans', Arial, sans-serif;\r\n      font-size: 30px;\r\n      line-height: 37px;\r\n      letter-spacing: -0.05em;\r\n      margin-left: 10px;\r\n    }\r\n\r\n    .logo-tagline-class {\r\n      font-weight: 500;\r\n      font-size: 12px;\r\n      line-height: 24px;\r\n      margin-left: 8px;\r\n    }\r\n\r\n    .logo-pipe-class {\r\n      margin-left: 8px;\r\n      font-style: normal;\r\n      font-weight: 100;\r\n      font-size: 30px;\r\n      line-height: 24px;\r\n      color: #ffffff;\r\n      opacity: 0.5;\r\n    }\r\n  }\r\n}\r\n\r\n.impact-container {\r\n  position: relative;\r\n}\r\n\r\n.before-after-wrapper {\r\n  .planner-simulate-grid {\r\n    position: relative;\r\n\r\n    .tile-it-button {\r\n      margin-top: 15px !important;\r\n      position: absolute;\r\n      top: -50px;\r\n      right: 0;\r\n    }\r\n\r\n    .simulate-grid {\r\n      position: absolute;\r\n      left: 4px;\r\n    }\r\n\r\n    .simulate-preview-header {\r\n      .MuiDataGrid-columnSeparator {\r\n        display: none;\r\n      }\r\n\r\n      .MuiDataGrid-columnHeaderTitleContainer {\r\n        padding: 0;\r\n      }\r\n\r\n      .MuiDataGrid-columnHeaderTitle {\r\n        font-weight: bold;\r\n        color: #555555;\r\n        text-transform: uppercase;\r\n      }\r\n    }\r\n\r\n    margin: 5px 0;\r\n\r\n    .simulate-preview {\r\n      color: #555555;\r\n      font-weight: bold;\r\n      width: 100%;\r\n      height: 400px;\r\n\r\n      .MuiDataGrid-root {\r\n        border: none;\r\n      }\r\n    }\r\n\r\n    .simulate-list-item {\r\n      background: rgba(255, 255, 255, 0.3);\r\n      border-radius: 8px;\r\n      margin-bottom: 6px;\r\n      font-size: 12px;\r\n      padding: 10px;\r\n      height: 45px;\r\n\r\n      .list-title {\r\n        width: 60%;\r\n        position: relative;\r\n        z-index: 1000;\r\n      }\r\n\r\n      .list-beforeId,\r\n      .list-afterId {\r\n        padding: 0;\r\n        width: 10%;\r\n        justify-content: right;\r\n      }\r\n\r\n      .list-beforeId {\r\n        padding: 4px;\r\n      }\r\n\r\n      .MuiListItemText-primary {\r\n        font-size: 12px;\r\n      }\r\n\r\n      .MuiListItemText-root {\r\n        // max-width: 30%;\r\n      }\r\n    }\r\n\r\n    .simulate-list-container {\r\n      margin-top: 30px;\r\n    }\r\n\r\n    .before-after-section {\r\n      display: flex;\r\n      justify-content: space-between;\r\n      // padding-top: 8px;\r\n      margin-left: auto;\r\n      max-width: 35%;\r\n\r\n      &>div:first-child {\r\n        margin-right: 8px;\r\n      }\r\n\r\n      .before-title {\r\n        font-weight: bold;\r\n        color: #555555;\r\n        text-transform: uppercase;\r\n        font-size: 14px;\r\n        color: #555555;\r\n        // margin-left: 8px;\r\n        border: 1px solid #555555;\r\n        height: 350px;\r\n        padding: 4px;\r\n        border-style: dashed;\r\n        border-radius: 10px;\r\n        width: 50%;\r\n        text-align: center;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.menu-items {\r\n  margin-top: 10px;\r\n}\r\n\r\n.d-block {\r\n  display: block;\r\n}\r\n\r\n.d-none {\r\n  display: none;\r\n}\r\n\r\n.profile-container {\r\n  padding: 0 !important;\r\n}\r\n\r\n.solutions-container {\r\n  padding: 0 !important;\r\n}\r\n\r\n.charts-container {\r\n  padding: 0 !important;\r\n}\r\n\r\n.direct-user-container {\r\n  padding-left: 0 !important;\r\n}\r\n\r\n.dashboard-container {\r\n  // display: flex;\r\n  padding: 20px 0px 0px 70px;\r\n\r\n  label,\r\n  input,\r\n  button,\r\n  .MuiInputBase-input,\r\n  .MuiMenuItem-root {\r\n    font-size: 12px;\r\n  }\r\n\r\n  .dropdown-class {\r\n    background: linear-gradient(180deg,\r\n        #ffffff 0%,\r\n        rgba(255, 255, 255, 0) 183.75%);\r\n  }\r\n\r\n  .no-chart-container {\r\n    .no-chart-div {\r\n      width: 350px;\r\n      height: 350px;\r\n    }\r\n  }\r\n\r\n  .chart-container {\r\n    padding: 50px 0px 0px 35px;\r\n    cursor: pointer;\r\n\r\n    .chart-div {\r\n      width: 350px;\r\n      height: 350px;\r\n    }\r\n\r\n    .inner-radius {\r\n      border-radius: 50px;\r\n      width: 88px;\r\n      height: 88px;\r\n      background: linear-gradient(92.79deg, #009fe3 6.52%, #00a19a 71.42%);\r\n      border: 1px solid #ffffff;\r\n      box-sizing: border-box;\r\n      top: 191px;\r\n      left: 166px;\r\n      text-align: center;\r\n      vertical-align: middle;\r\n      position: absolute;\r\n      box-shadow: 0 0 10px 1px #ffffff inset;\r\n      padding-top: 35px;\r\n      color: #ffffff;\r\n      font-size: 10px;\r\n    }\r\n\r\n    .inner-radius-unsubscribed {\r\n      border-radius: 50px;\r\n      width: 88px;\r\n      height: 88px;\r\n      border: 1px solid #ffffff;\r\n      box-sizing: border-box;\r\n      top: 191px;\r\n      left: 166px;\r\n      text-align: center;\r\n      vertical-align: middle;\r\n      position: absolute;\r\n      box-shadow: 0 0 10px 1px #ffffff inset;\r\n      padding-top: 35px;\r\n      color: black;\r\n      font-size: 10px;\r\n    }\r\n\r\n    .link-style {\r\n      text-decoration: none;\r\n      vertical-align: middle;\r\n    }\r\n\r\n    .link-text {\r\n      font-size: 10px;\r\n      color: black;\r\n      vertical-align: top;\r\n    }\r\n  }\r\n\r\n  .ds-common-container {\r\n    width: 100% !important;\r\n    padding: 10px !important;\r\n  }\r\n\r\n  .common-container {\r\n    .MuiAccordionSummary-root {\r\n      min-height: 25px;\r\n      // .MuiAccordionSummary-content {\r\n      //   margin: 0;\r\n      // }\r\n    }\r\n\r\n    .MuiAccordionDetails-root {\r\n      padding-top: 0;\r\n    }\r\n\r\n    padding: 60px 0px 10px 0px;\r\n    width: 74%;\r\n\r\n    .chrono-charts-container {\r\n      background: rgba(255, 255, 255, 0.3);\r\n      //border: 2px solid #ffffff;\r\n      box-sizing: border-box;\r\n      box-shadow: -5px 4px 34px rgb(85 85 85 / 4%);\r\n      border-radius: 10px;\r\n      min-height: 62px;\r\n      margin: 15px 0px 10px 0px;\r\n      padding: 10px;\r\n\r\n      .chrono-list-wrapper {\r\n        padding: 0px !important;\r\n        border: 1px solid #e0e0e0;\r\n        border-radius: 4px;\r\n        margin-top: 2px;\r\n      }\r\n    }\r\n  }\r\n\r\n  .status-list-container {\r\n    //background: linear-gradient(180deg, #16899d 0%, #6ccea6 100%);\r\n    background: #479573;\r\n    width: 80%;\r\n    border-radius: 12px;\r\n    padding: 8px 20px 2px 20px;\r\n    margin: 45px 0px 10px 40px;\r\n\r\n    .status-list-div {\r\n      min-height: 385px;\r\n      max-height: 450px;\r\n      overflow: auto;\r\n    }\r\n\r\n    .status-list {\r\n      list-style: none;\r\n      color: white;\r\n      font-size: 12px;\r\n      padding: 0px;\r\n    }\r\n\r\n    .list-item {\r\n      cursor: pointer;\r\n      padding: 8px 16px;\r\n\r\n      &-current {\r\n        background: rgba(255, 255, 255, 0.75);\r\n        border: 1px solid rgba(225, 253, 151, 0.3);\r\n        box-sizing: border-box;\r\n        border-radius: 7px;\r\n\r\n        .label {\r\n          color: black;\r\n        }\r\n\r\n        .list-item-label {\r\n          font-style: normal;\r\n          font-weight: 500;\r\n          font-size: 14px;\r\n          line-height: 16px;\r\n          color: #000000;\r\n        }\r\n      }\r\n    }\r\n\r\n    .status-title {\r\n      font-style: normal;\r\n      font-weight: bold;\r\n      font-size: 18px;\r\n      line-height: 21px;\r\n      text-transform: uppercase;\r\n      color: #ffffff;\r\n      margin-bottom: 20px;\r\n    }\r\n\r\n    .hr-line {\r\n      border-top: 0.5px dashed white;\r\n      margin: 0 16px 0 16px;\r\n    }\r\n\r\n    .notes-section {\r\n\r\n      // padding: 5px;\r\n      .MuiTextField-root {\r\n        input::placeholder {\r\n          font-size: 10px;\r\n        }\r\n\r\n        .MuiOutlinedInput-root {\r\n          border: 1px solid #00a19a !important;\r\n          box-sizing: border-box;\r\n          border-radius: 13px;\r\n        }\r\n      }\r\n\r\n      .MuiTextField-root {\r\n        width: 230px;\r\n        background: linear-gradient(180deg,\r\n            #ffffff 0%,\r\n            rgba(255, 255, 255, 0) 357.5%);\r\n        border: 1px solid #ffffff;\r\n        box-sizing: border-box;\r\n        border-radius: 13px;\r\n      }\r\n\r\n      .MuiInputBase-input {\r\n        padding: 8px 0;\r\n      }\r\n\r\n      .text-container {\r\n        margin-top: 10px;\r\n        width: 230px;\r\n        position: relative;\r\n\r\n        .text-icon {\r\n          button {\r\n            border: none;\r\n            background: none;\r\n            color: #009fe3;\r\n            cursor: pointer;\r\n          }\r\n\r\n          position: absolute;\r\n          right: 0;\r\n          bottom: 0;\r\n          padding: 10px 10px 5px 10px;\r\n        }\r\n\r\n        textarea {\r\n          &::placeholder {\r\n            font-size: 10px;\r\n          }\r\n\r\n          font-style: normal;\r\n          font-weight: normal;\r\n          font-size: 14px;\r\n          line-height: 24px;\r\n          background: linear-gradient(180deg,\r\n            #ffffff 0%,\r\n            rgba(255, 255, 255, 0) 357.5%);\r\n          border: 1px solid #ffffff;\r\n          box-sizing: border-box;\r\n          border-radius: 13px;\r\n          resize: none;\r\n          width: 100%;\r\n          padding: 8px 12px;\r\n        }\r\n      }\r\n\r\n      .comment-box {\r\n        font-style: normal;\r\n        font-weight: normal;\r\n        font-size: 10px;\r\n        color: #ffffff;\r\n        width: 230px;\r\n        background: rgba(255, 255, 255, 0.3);\r\n        box-shadow: 0px 0px 34px rgba(0, 0, 0, 0.02);\r\n        border-radius: 10px;\r\n        border-radius: 8px;\r\n        margin-top: 8px;\r\n        padding: 10px;\r\n        justify-content: space-between;\r\n\r\n        &>div {\r\n          display: flex;\r\n          justify-content: space-between;\r\n        }\r\n\r\n        &>div:nth-child(2) {\r\n          margin-bottom: 10px;\r\n        }\r\n\r\n        p {\r\n          margin: 0;\r\n          word-break: break-all;\r\n        }\r\n\r\n        .delete-icon {\r\n          button {\r\n            border: none;\r\n            background: none;\r\n            color: #ffffff;\r\n            cursor: pointer;\r\n          }\r\n        }\r\n      }\r\n\r\n      .notes-section-div {\r\n        min-height: 385px;\r\n        max-height: 450px;\r\n        overflow: auto;\r\n      }\r\n\r\n      .search-comments-container {\r\n        padding-top: 20px;\r\n      }\r\n    }\r\n  }\r\n\r\n  .dashboard-top-div {\r\n    display: flex;\r\n    margin-left: 10px;\r\n\r\n    .label-class {\r\n      background: rgba(255, 255, 255, 0.5);\r\n      border: 2px solid #ffffff;\r\n      box-sizing: border-box;\r\n      border-radius: 13px;\r\n      align-items: flex-start;\r\n      padding: 10px 5px;\r\n      font-style: normal;\r\n      font-weight: 300;\r\n      font-size: 14px;\r\n      line-height: 31px;\r\n\r\n      .label-value {\r\n        font-weight: bold;\r\n        color: #312c50;\r\n      }\r\n    }\r\n\r\n    .loggedIn-advisor-class {\r\n      padding: 8px 8px 0px 8px;\r\n      background: linear-gradient(270deg, #1e4438 -17.61%, #3a957d 95.49%);\r\n      border-radius: 10px;\r\n      color: #ffffff;\r\n      font-style: normal;\r\n      font-weight: 300;\r\n      font-size: 14px;\r\n      line-height: 24px;\r\n      margin-right: 10px;\r\n      height: 50px;\r\n      margin-top: 8px;\r\n\r\n      .loggedIn-advisor-name {\r\n        font-weight: bold;\r\n        flex: none;\r\n        order: 0;\r\n        flex-grow: 0;\r\n      }\r\n    }\r\n  }\r\n\r\n  .chrono-container,\r\n  .dashboard-summary-container {\r\n    .MuiAccordion-root {\r\n      position: relative;\r\n    }\r\n\r\n    .MuiAccordionSummary-expandIconWrapper {\r\n      // position: absolute;\r\n      // left: 10px;\r\n    }\r\n\r\n    .MuiAccordionSummary-content {\r\n      margin: 0 0 0 18px;\r\n    }\r\n\r\n    .dashboard-charts {\r\n      .MuiAccordionSummary-content {\r\n        font-size: 14px;\r\n        font-weight: 600;\r\n        padding-top: 6px;\r\n        display: flex;\r\n        justify-content: space-between;\r\n      }\r\n    }\r\n\r\n    .chrono-tabs-container {\r\n      //background: linear-gradient(180deg, #16899d 0%, #6ccea6 100%);\r\n      background: #479573;\r\n      border: 2px solid #ffffff;\r\n      box-sizing: border-box;\r\n      box-shadow: -5px 4px 34px rgba(85, 85, 85, 0.04);\r\n      border-radius: 10px;\r\n      width: 100%;\r\n      min-height: 50px;\r\n      margin: 0 0px 0px 0px;\r\n      padding: 0px;\r\n\r\n      .chrono-list-wrapper {\r\n        display: flex;\r\n        list-style: none;\r\n        color: white;\r\n        font-size: 12px;\r\n        padding: 0px;\r\n      }\r\n\r\n      .chrono-list {\r\n        cursor: pointer;\r\n        padding: 0px 10px;\r\n        font-size: 12px;\r\n        color: #ffffff;\r\n        line-height: 14.06px;\r\n        text-transform: uppercase;\r\n\r\n        &-current {\r\n          color: #ffffff;\r\n          font-weight: bold;\r\n          text-transform: uppercase;\r\n          border-radius: 8px;\r\n\r\n          .label {\r\n            color: #009fe3;\r\n          }\r\n\r\n          .tab-heading {\r\n            border-bottom: 2px solid #ffffff;\r\n            padding-bottom: 4px;\r\n          }\r\n\r\n          .chrono-list-icon {\r\n            height: 28px;\r\n            width: 28px;\r\n            border-radius: 50%;\r\n            color: #e0e0e0;\r\n            background-color: #009fe3;\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .chrono-tabs-wrapper {\r\n      //background: linear-gradient(180deg, #16899d 0%, #6ccea6 100%);\r\n      background: #479573;\r\n      border: 2px solid #ffffff;\r\n      box-sizing: border-box;\r\n      box-shadow: -5px 4px 34px rgba(85, 85, 85, 0.04);\r\n      border-radius: 10px;\r\n      // width: 73%;\r\n      min-height: 62px;\r\n      margin: 0px;\r\n      padding: 10px;\r\n    }\r\n\r\n    .chrono-parent-tab {\r\n      .MuiTabs-root {\r\n        border-bottom: 1px solid #e0e0e0;\r\n        min-height: 30px;\r\n      }\r\n\r\n      .MuiTab-root {\r\n        font-size: 12px;\r\n        // font-weight: bold;\r\n        color: white;\r\n        min-height: 30px;\r\n        height: 40px;\r\n      }\r\n\r\n      .Mui-selected {\r\n        font-weight: bold;\r\n\r\n        .MuiTouchRipple-root {\r\n          border-bottom: 2px solid #ffffff;\r\n        }\r\n      }\r\n    }\r\n\r\n    .chrono-sub-tab {\r\n      margin: 4px 16px;\r\n\r\n      .MuiTab-root {\r\n        font-size: 10px;\r\n        // font-weight: bold;\r\n        color: white;\r\n        min-height: 30px;\r\n        height: 40px;\r\n      }\r\n\r\n      .Mui-selected {\r\n        font-weight: bold;\r\n\r\n        .MuiTouchRipple-root {\r\n          border-bottom: 2px solid #ffffff;\r\n        }\r\n      }\r\n    }\r\n\r\n    .chrono-content-container {\r\n      background: rgba(255, 255, 255, 0.3);\r\n      //border: 2px solid #ffffff;\r\n      box-sizing: border-box;\r\n      box-shadow: -5px 4px 34px rgba(85, 85, 85, 0.04);\r\n      border-radius: 5px;\r\n      min-height: 62px;\r\n      margin: 15px 0px 10px 0px;\r\n      padding: 10px;\r\n\r\n      .chrono-list-wrapper {\r\n        display: flex;\r\n        list-style: none;\r\n        color: white;\r\n        font-size: 12px;\r\n        padding: 0px;\r\n      }\r\n\r\n      .chrono-list {\r\n        cursor: pointer;\r\n        // padding: 0px 10px;\r\n        font-size: 12px;\r\n        font-weight: bold;\r\n        font-style: normal;\r\n        // text-transform: capitalize;\r\n        line-height: 35px;\r\n        color: #1e106b;\r\n\r\n        .chrono-sub-header {\r\n          margin-left: 5px;\r\n          font-style: normal;\r\n          font-weight: bold;\r\n          font-size: 12px;\r\n          line-height: 35px;\r\n          color: #1e106b;\r\n        }\r\n\r\n        .chrono-list-icon {\r\n          height: 28px;\r\n          width: 28px;\r\n          border-radius: 50%;\r\n          color: #059baf;\r\n        }\r\n      }\r\n\r\n      .chrono-content-items {\r\n        align-items: center;\r\n        list-style: none;\r\n        padding-left: 5px;\r\n\r\n        .chrono-item {\r\n          background: rgba(255, 255, 255, 0.5);\r\n          box-shadow: 0px 0px 34px rgba(0, 0, 0, 0.02);\r\n          border-radius: 10px;\r\n          flex: none;\r\n          order: 1;\r\n          flex-grow: 0;\r\n          margin: 1px 0px;\r\n          font-weight: normal;\r\n          font-size: 14px;\r\n          line-height: 35px;\r\n          color: #000000;\r\n          padding: 2px;\r\n\r\n          .chrono-wrapper {\r\n            display: flex;\r\n            justify-content: space-between;\r\n          }\r\n\r\n          .chrono-label {\r\n            font-size: 13px;\r\n            color: #555555;\r\n            padding: 1px;\r\n            margin-left: 5px;\r\n          }\r\n\r\n          .chrono-value {\r\n            font-size: 13px;\r\n            color: black;\r\n            justify-content: flex-end;\r\n            margin-right: 8px;\r\n          }\r\n\r\n          .chrono-label-no-tooltip {\r\n            padding: 1px;\r\n            font-size: 13px;\r\n            color: #555555;\r\n\r\n            &:hover {\r\n              background: rgba(203, 249, 255, 0.5);\r\n              border: 1px dashed #009fe3;\r\n              box-sizing: border-box;\r\n              box-shadow: 0px 0px 23px rgba(2, 209, 255, 0.3);\r\n              border-radius: 2px 10px 10px 10px;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    // border: 1px solid #ffffff;\r\n    box-sizing: border-box;\r\n    box-shadow: -5px 4px 34px rgb(85 85 85 / 4%);\r\n    border-radius: 10px;\r\n    margin: 5px 0px 0px 0px;\r\n    padding: 5px 5px 0px 5px;\r\n  }\r\n\r\n  .chrono-wrapper {\r\n    max-height: 580px;\r\n    overflow-y: auto;\r\n    padding: 0px 5px 5px 5px;\r\n    //border: 1px solid #ffff;\r\n  }\r\n\r\n  .dashboard-summary-container {\r\n    .chrono-content-container {\r\n      border: none;\r\n      padding: 10px;\r\n\r\n      .chrono-list {\r\n        margin-bottom: 10px;\r\n        cursor: default;\r\n      }\r\n    }\r\n  }\r\n\r\n  .popover-container {\r\n    .popover-item {\r\n      &:hover {\r\n        background: rgba(203, 249, 255, 0.5);\r\n        border: 1px dashed #009fe3;\r\n        box-sizing: border-box;\r\n        box-shadow: 0px 0px 23px rgba(2, 209, 255, 0.3);\r\n        border-radius: 2px 10px 10px 10px;\r\n      }\r\n    }\r\n\r\n    .chrono-list-wrapper {\r\n      display: flex;\r\n      list-style: none;\r\n      color: white;\r\n      font-size: 12px;\r\n      padding: 0px;\r\n    }\r\n\r\n    .chrono-list {\r\n      cursor: pointer;\r\n      padding: 0px 15px;\r\n      font-size: 12px;\r\n      font-weight: bold;\r\n      font-style: normal;\r\n      text-transform: capitalize;\r\n      line-height: 35px;\r\n      color: #1e106b;\r\n\r\n      .chrono-sub-header {\r\n        margin-left: 5px;\r\n      }\r\n    }\r\n\r\n    .chrono-content-items {\r\n      align-items: center;\r\n      list-style: none;\r\n      padding-left: 5px;\r\n\r\n      .chrono-item {\r\n        background: rgba(255, 255, 255, 0.5);\r\n        box-shadow: 0px 0px 34px rgba(0, 0, 0, 0.02);\r\n        border-radius: 10px;\r\n        flex: none;\r\n        order: 1;\r\n        flex-grow: 0;\r\n        margin: 1px 0px;\r\n        font-weight: normal;\r\n        font-size: 14px;\r\n        line-height: 35px;\r\n        color: #000000;\r\n        padding: 2px;\r\n\r\n        .chrono-label {\r\n          font-size: 13px;\r\n          color: #555555;\r\n          padding: 2px;\r\n          margin-left: 5px;\r\n        }\r\n\r\n        .chrono-value {\r\n          font-size: 13px;\r\n          color: black;\r\n          justify-content: flex-end;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.client-dashboard-title {\r\n  display: grid;\r\n  grid-template-columns: 2fr 3fr 2fr;\r\n  grid-template-rows: 50px;\r\n  font-size: 18px;\r\n  font-weight: 400;\r\n}\r\n\r\n.client-dashboard-fields,\r\n.add-new-plan-fields {\r\n  // display: grid;\r\n  grid-template-columns: 0.1fr 3fr 0.1fr;\r\n  grid-template-rows: 50px;\r\n\r\n  .client-dropdown {\r\n    width: 100%;\r\n    padding: 10px;\r\n  }\r\n\r\n  .plan-dropdown {\r\n    width: 100%;\r\n    padding: 10px;\r\n  }\r\n\r\n  .plan-name-field {\r\n    width: 100%;\r\n    padding: 5px;\r\n  }\r\n}\r\n\r\n.planner-container {\r\n  .faq-container {\r\n    box-sizing: border-box;\r\n    box-shadow: -5px 4px 34px rgba(85, 85, 85, 0.04);\r\n    border-radius: 5px;\r\n    padding: 5px;\r\n\r\n    .faq-content-items {\r\n      .faq-item {\r\n        background: rgba(255, 255, 255, 0.5);\r\n        box-shadow: 0px 0px 34px rgba(0, 0, 0, 0.02);\r\n        border-radius: 10px;\r\n        flex: none;\r\n        order: 1;\r\n        flex-grow: 0;\r\n        margin: 1px 0px;\r\n        font-weight: normal;\r\n        font-size: 14px;\r\n        line-height: 25px;\r\n        color: #000000;\r\n        padding: 2px;\r\n\r\n        .faq-question {\r\n          font-size: 13px;\r\n          color: #555555;\r\n        }\r\n\r\n        .faq-answer {\r\n          font-size: 13px;\r\n          color: black;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.dashboard-planner-fields {\r\n  .field-item {\r\n    // background: rgba(255, 255, 255, 0.3);\r\n    // padding-left: 4px;\r\n    // margin-bottom: 8px;\r\n    // border-radius: 10px;\r\n    height: 45px;\r\n  }\r\n\r\n  .field-label {\r\n    font-size: 12px;\r\n    padding: 10px;\r\n    // margin-top: 8px;\r\n    border-right: 1px solid #ffffff;\r\n  }\r\n\r\n  .field-member {\r\n    height: 35px;\r\n    border-right: 1px solid #ffffff;\r\n    text-align: center;\r\n    text-transform: uppercase;\r\n    font-size: 12px;\r\n    font-weight: bold;\r\n    padding: 10px;\r\n  }\r\n\r\n  .planner-input-grid {\r\n    box-sizing: border-box;\r\n    // box-shadow: -5px 4px 34px rgb(85 85 85 / 4%);\r\n    text-align: center;\r\n\r\n    // border-left: 1px solid #ffffff;\r\n    &:last-child {\r\n      border-right: 1px solid #ffffff;\r\n    }\r\n\r\n    &>div {\r\n      // padding: 8px;\r\n      // margin-bottom: 8px;\r\n      border-radius: 10px;\r\n    }\r\n\r\n    .error-text {\r\n      padding: 0;\r\n      margin: 0;\r\n      font-size: 10px;\r\n      color: red;\r\n    }\r\n\r\n    .error-field {\r\n      border-color: red;\r\n    }\r\n\r\n    // background: rgba(255, 255, 255, 0.3);\r\n    .input-value {\r\n      border-radius: 45px 50px 5px 50px;\r\n      color: #000;\r\n      padding: 5px 5px;\r\n      //background: linear-gradient(180.61deg, #32a3b2 29.35%, #61b76e 90.9%);\r\n      background: linear-gradient(270deg, #41b6c4 -17.61%, #7fcdbb 95.49%);\r\n      // width: auto;\r\n      font-size: 11px;\r\n      // height: 25px; //visit again\r\n      text-align: center;\r\n      margin-top: 8px;\r\n      margin-right: 5px;\r\n      margin-bottom: 5px;\r\n      display: inline;\r\n    }\r\n  }\r\n\r\n  .member-field-disabled {\r\n    background-color: lightgray;\r\n  }\r\n\r\n  .planner {\r\n    &-input {\r\n      border-radius: 8px;\r\n      border: 0.5px solid #61b76e;\r\n      width: 100%;\r\n      height: 30px;\r\n      padding: 4px;\r\n\r\n      &:focus-visible {\r\n        outline: none;\r\n      }\r\n\r\n      &-hide {\r\n        opacity: 0;\r\n        height: 0;\r\n        width: 0;\r\n      }\r\n\r\n      &-show {\r\n        opacity: 1;\r\n        // max-height: 100%;\r\n        transition: all 0.3s ease-out;\r\n        -webkit-transition: all 0.3s ease-out;\r\n\r\n        // padding-top: 8px;\r\n        svg {\r\n          vertical-align: middle;\r\n        }\r\n\r\n        .select {\r\n          width: 80%;\r\n          border-color: #61b76e;\r\n          border-radius: 8px;\r\n          padding: 4px 0;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .row-wrapper {\r\n    border-top: 1px solid #ffffff;\r\n    border-left: 1px solid #ffffff;\r\n    border-bottom: 1px solid #ffffff;\r\n  }\r\n}\r\n\r\n.goals-answer-container {\r\n  padding: 0px !important;\r\n\r\n  .chrono-wrapper {\r\n    padding: 0 5px 0;\r\n    border-radius: 0;\r\n  }\r\n\r\n  .goals-label {\r\n    &:nth-child(2) {\r\n      border-left: 2px solid #fff;\r\n      border-right: 2px solid #fff;\r\n    }\r\n  }\r\n}\r\n\r\n.MuiPickersBasePicker-container {\r\n  .MuiPickersToolbar-toolbar {\r\n    background: linear-gradient(180deg, #6ccea6 0%, #16899d 100%) rgba(255, 255, 255, 0.75);\r\n    height: 70px;\r\n  }\r\n\r\n  .MuiTypography-colorPrimary {\r\n    color: rgba(56, 211, 100, 0.75) !important;\r\n  }\r\n\r\n  .MuiTypography-h3 {\r\n    font-size: 2rem;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
